import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import { AppLayout } from 'containers';
import { BucketBlock, Masonry, PageHeader, Spinner } from 'components';
import { connect } from 'react-redux';
var ContentDirectory = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    organization: state.organization.current,
    buckets: state.contentLibraryContent.buckets
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentDirectory, _Component);

  var _super = _createSuper(ContentDirectory);

  function ContentDirectory() {
    _classCallCheck(this, ContentDirectory);

    return _super.apply(this, arguments);
  }

  _createClass(ContentDirectory, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this = this;

      var hasSocialAccount = false;

      if (this.props.organization.SocialAccounts) {
        if (this.props.organization.SocialAccounts.length) {
          hasSocialAccount = true;
        }
      }

      var bucketBlocks = this.props.buckets.map(function (bucket) {
        return /*#__PURE__*/React.createElement(BucketBlock, {
          data: bucket,
          onClick: function onClick() {
            console.log('clicked block');
            browserHistory.push("/org/".concat(_this.props.organization.id, "/content/bucket/").concat(bucket.slug));
          }
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Content Library"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-11"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Content Library"
      })), /*#__PURE__*/React.createElement("span", {
        className: "col-xs-1"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-search",
        style: {
          color: '#616161',
          cursor: 'pointer',
          fontSize: 26,
          position: 'relative',
          top: 12
        },
        onClick: function onClick() {
          _this.props.openSearchModal();
        }
      }))), /*#__PURE__*/React.createElement(Masonry, {
        bricks: bucketBlocks
      }))));
    }
  }]);

  return ContentDirectory;
}(Component)) || _class);
export default ContentDirectory;